import { Component, Inject } from '@angular/core';
import {
    FiDataFieldView_DataField,
    FiDataFieldView_DataFieldObject,
    FiDataFieldViewBase,
} from '@fi-app/data-field/data-field-view/data-field-view-base';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';
import { BusinessUnitService } from '@fi-app/business-unit/business-unit.service';

@Component({
    selector: 'data-field-units',
    templateUrl: './units.component.html',
    standalone: false,
})
export class FiDataFieldViewUnitsComponent extends FiDataFieldViewBase {
    FiStateNames = FiStateNames;

    constructor(
        @Inject(FiDataFieldView_DataField) dataField: DataFieldModel,
        @Inject(FiDataFieldView_DataFieldObject) dataFieldObject: any,
        private businessUnitService: BusinessUnitService,
    ) {
        super(dataField, dataFieldObject);
    }

    get isNotEmpty() {
        return this.dataFieldObject.BusinessUnits && this.dataFieldObject.BusinessUnits.length > 0;
    }

    openBusinessUnitViewDialog(businessUnitId: number) {
        this.businessUnitService.openBusinessUnitViewDialog(businessUnitId);
    }
}
